import { FiFacebook, FiInstagram, FiYoutube } from 'react-icons/fi'
import { FaLinkedinIn } from 'react-icons/fa'
import { BiPhoneCall } from 'react-icons/bi'
import { Col, Row } from 'reactstrap'
import { ApplicationState } from 'store'
import { LANDING_PAGE } from 'store/modules/landingPage/types'
import { useSelector } from 'react-redux'
import * as landingPageActions from 'store/modules/landingPage/actions'
import useRedux from 'hooks/useRedux'
import ModalPdf from './Modals/ModalPdf'
import { MdEmail } from 'react-icons/md'
import { HashLink } from 'react-router-hash-link'
import history from 'util/history'
import { Link } from 'react-router-dom'

const Footer = () => {
  const { downloads, loadingDownloads, modalPdf } = useSelector<
    ApplicationState,
    LANDING_PAGE
  >((state) => state.landingPage)

  const { dispatch } = useRedux()

  return (
    <footer>
      <div className="container">
        <div className="container">
          <Row>
            <Col className="py-5">
              <img
                src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/logo_2.png"
                height={30}
              />
            </Col>
          </Row>
          <Row className="contato">
            <Col md={6} className="d-flex flex-column align-items-md-center">
              <div className="d-flex flex-column col-300">
                <HashLink className="link" to="/#produtos">
                  Produtos
                </HashLink>
                <HashLink className="link" to="/sobre">
                  Sobre
                </HashLink>
                <a
                  className="link"
                  href="https://www.riberseguros.com.br"
                  target="_blank"
                  rel="noreferrer"
                >
                  Seguros
                </a>
                <HashLink className="link" to="/">
                  Blog
                </HashLink>
                <HashLink className="link" to="/seja-parceiro">
                  Seja Parceiro
                </HashLink>
                <HashLink className="link" to="/trabalhe-conosco">
                  Trabalhe conosco
                </HashLink>
              </div>
            </Col>
            <Col md={6} className="d-flex flex-column align-items-md-center ">
              <div className="d-flex flex-column justify-content-between h-100 col-300 gap-2">
                <div className="dark-bold">Fale com a gente</div>
                <div>
                  <BiPhoneCall className="icon" />
                  0800 941 1111
                </div>
                <a
                  className="link"
                  href="https://forms.office.com/pages/responsepage.aspx?id=Y_zNRfPiX0CF6FLzi_WsGghRHazoVFZMr__EVaZuMVBUNEYyV0JUVkdQOFlVRTJTQTU1T1NNOVdXVC4u"
                  target="_blank"
                  rel="noreferrer"
                >
                  <MdEmail className="icon" />
                  Ouvidoria
                </a>
                <div className="d-flex ">
                  <a
                    target="_blank"
                    href="https://www.facebook.com/ribercred/"
                    rel="noreferrer"
                  >
                    <FiFacebook className="icon" />
                  </a>
                  <a
                    target="_blank"
                    className="youtube"
                    href="https://www.youtube.com/channel/UCBq11uE1in7u3-NeIiJxDng/featured"
                    rel="noreferrer"
                  >
                    <FiYoutube className="icon" />
                  </a>
                  <a
                    target="_blank"
                    className="instagram"
                    href="https://www.instagram.com/riberbr/"
                    rel="noreferrer"
                  >
                    <FiInstagram className="icon" />
                  </a>
                  <a
                    target="_blank"
                    className="linkedin"
                    href="https://br.linkedin.com/company/riber-servicos-financeiros"
                    rel="noreferrer"
                  >
                    <FaLinkedinIn className="icon" />
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div className="informacoes">
          <span>
            © {new Date().getFullYear()} Riber – A plataforma Riber não realiza
            análise de crédito, e a liberação do valor na conta do cliente é de
            responsabilidade única e exclusiva das instituições financeiras
            parceiras. A aprovação de créditos consignados descritos nesta
            plataforma está sujeita à validação da margem consignável e à
            averbação por parte do órgão pagador. Já a aprovação do crédito
            referente ao produto Antecipação do FGTS está sujeita à
            disponibilidade do saldo fornecido pela Caixa Econômica Federal, bem
            como às políticas das instituições financeiras parceiras. Embora a
            Riber trabalhe para democratizar o acesso ao crédito nas melhores
            condições e taxas de juros praticadas no empréstimo consignado e no
            cartão de crédito consignado, tais condições são determinadas pelas
            instituições financeiras parceiras, devendo ser confirmadas e
            exibidas antes de qualquer contratação
          </span>
          <span>Todo crédito deve ser utilizado de forma consciente.</span>
        </div>
        <div className="informacoes">
          <span>
            A Ribercred, com sede à Avenida Antônio Diederichsen, nº. 400, sala
            16, Jardim América, CEP: 14020-250, Ribeirão Preto, Estado de São
            Paulo, inscrita no CNPJ sob o nº. 04.380.132/0001-47, atua como
            correspondente bancário, atividade regulada pelo Banco Central do
            Brasil, nos termos da Resolução nº 3.954 das instituições
            financeiras: Banco Itaú Consignado S/A, Banco BMG S/A, Banco
            Daycoval S/A, Banco Master S/A, Banco Pan S/A, Franqueados da Help!
            Franchising, Creditas Soluções Financeiras LTDA, Crefaz Scm EPP
            LTDA, Vctex Correspondente Bancário e Meios de Pagamentos LTDA,
            Icred Soluções Financeiras S/A, BV Financeira S/A, Banco Santander
            (Brasil) S/A, Banco Mercantil do Brasil S/A, Start Serviços
            Administrativos LTDA, Banco Paulista S/A, Banco C6 Consignado S/A,
            Banco Digio S/A, Banco do Brasl S/A, Banco Safra S/A.
          </span>
        </div>
        <div className="copyright">
          <Link
            onClick={() => {
              history.push('/aviso-privacidade')
              setTimeout(() => window.scrollTo(0, 0), 0)
            }}
            to="/aviso-privacidade"
            target="_self"
            color="transparent"
          >
            AVISO DE PRIVACIDADE
          </Link>
          <Link
            onClick={() => {
              history.push('/politica-privacidade')
              setTimeout(() => window.scrollTo(0, 0), 0)
            }}
            to="/politica-privacidade"
            target="_self"
            color="transparent"
          >
            POLÍTICA DE PRIVACIDADE
          </Link>
          <Link
            onClick={() => {
              history.push('/termo-de-uso')
              setTimeout(() => window.scrollTo(0, 0), 0)
            }}
            to="/termo-de-uso"
            target="_self"
            color="transparent"
          >
            TERMO DE POLÍTICA E USO
          </Link>
        </div>
        <ModalPdf
          isOpen={modalPdf}
          toggle={() => {
            dispatch(landingPageActions.setModalPdf(false))
          }}
          pdf={downloads.pdf}
          loading={loadingDownloads.pdf}
        />
      </div>
    </footer>
  )
}

export default Footer
